import React from 'react';
import tagular from '../../../../../util/tagular';
import close from '../../../../../assets/close-small.svg';
import closeMnt from '../../../../../assets/close-small-mnt.svg';
import './filterItem.scss';

const handleClick = (e, props) => {
    tagular.sendElementClickedEvent(e, {
        assessmentName: props.assessmentName,
        name: 'Filtered by',
        text: props.filter,
        action: 'FILTER'
    });

    return props.handleSelect(props.filter);
};

const FilterItem = props => {
    return (
        <div className={`result-filter ${props.site}`}>
            <div className={`result-filter-content ${props.site}`} onClick={e => handleClick(e, props)}>
                <span>{props.filter}</span>
                <div className="close-icon-container button">
                    <img className="close icon" src={props.site && props.site == 'mnt' ? closeMnt : close} alt="Remove Filter" />
                </div>
            </div>
        </div>
    );
};

export default FilterItem;
